import React from 'react';
import { FaUser, FaCheck, FaExclamationTriangle, FaClock } from 'react-icons/fa';
import { useChat } from '../../context/ChatContext';
import '../../css/Chat.css';

const MessageItem = ({ message, showAvatar = true, isGrouped = false }) => {
  const { currentUser } = useChat();

  // Check if message is from current user (compare both ID and type)
  // Backend messages have user_type='backend', client messages have user_type='client'
  const isOwnMessage = message.user_id === currentUser?.id &&
                       (!message.user_type || message.user_type === 'client');
  const isSystemMessage = message.message_type === 'system';
  const hasError = message.error;
  const isSending = message.sending;
  const isSent = message.sent;

  // Idő formázás
  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    
    try {
      // Ha a timestamp string, akkor parse-oljuk
      let date;
      if (typeof timestamp === 'string') {
        // Ha a timestamp UTC formátumban van (pl. "2024-01-01T12:00:00Z")
        if (timestamp.includes('Z') || timestamp.includes('+')) {
          date = new Date(timestamp);
        } else {
          // Ha nincs időzóna jelölés, akkor helyi időként kezeljük
          date = new Date(timestamp + 'Z');
        }
      } else {
        date = new Date(timestamp);
      }
      
      // Ellenőrizzük, hogy érvényes-e a dátum
      if (isNaN(date.getTime())) {
        console.warn('Érvénytelen timestamp:', timestamp);
        return '';
      }
      
      // Helyi időben jelenítjük meg
      return date.toLocaleTimeString('hu-HU', { 
        hour: '2-digit', 
        minute: '2-digit',
        timeZone: 'Europe/Budapest'
      });
    } catch (error) {
      console.error('Hiba az idő formázásakor:', error, timestamp);
      return '';
    }
  };

  // Dátum formázás (jelenleg nem használt, de később hasznos lehet)
  // const formatDate = (timestamp) => {
  //   if (!timestamp) return '';
  //   
  //   const date = new Date(timestamp);
  //   const today = new Date();
  //   const yesterday = new Date(today);
  //   yesterday.setDate(yesterday.getDate() - 1);
  //   
  //   if (date.toDateString() === today.toDateString()) {
  //     return 'Ma';
  //   } else if (date.toDateString() === yesterday.toDateString()) {
  //     return 'Tegnap';
  //   } else {
  //     return date.toLocaleDateString('hu-HU', {
  //       year: 'numeric',
  //       month: 'long',
  //       day: 'numeric'
  //     });
  //   }
  // };

  // Rendszer üzenet
  if (isSystemMessage) {
    return (
      <div className="chat-message system">
        <div className="chat-message-content system">
          {message.message}
        </div>
        <div className="chat-message-time">
          {formatTime(message.created_at)}
        </div>
      </div>
    );
  }

  return (
    <div className={`chat-message ${isOwnMessage ? 'own' : 'other'} ${isGrouped ? 'grouped' : ''}`}>
      {/* Avatar (csak ha nem grouped és nem saját üzenet) */}
      {showAvatar && !isOwnMessage && !isGrouped && (
        <div className="chat-message-avatar">
          <FaUser />
        </div>
      )}

      <div className="chat-message-bubble">
        {/* Küldő neve (csak ha nem grouped és nem saját üzenet) */}
        {!isOwnMessage && !isGrouped && (
          <div className="chat-message-sender">
            {message.user_name || 'Ismeretlen felhasználó'}
          </div>
        )}

        {/* Üzenet tartalom */}
        <div className={`chat-message-content ${hasError ? 'error' : ''} ${isSending ? 'sending' : ''}`}>
          {/* Szöveges üzenet */}
          {message.message_type === 'text' && (
            <span className="message-text">{message.message}</span>
          )}

          {/* Kép üzenet */}
          {message.message_type === 'image' && (
            <div className="message-image">
              <img src={message.message} alt="Üzenet kép" />
            </div>
          )}
        </div>

        {/* Üzenet meta információk */}
        <div className="chat-message-meta">
          <span className="chat-message-time">
            {formatTime(message.created_at)}
          </span>

          {/* Státusz ikonok (csak saját üzeneteknél) */}
          {isOwnMessage && (
            <div className="message-status">
              {isSending && (
                <FaClock className="status-icon sending" title="Küldés folyamatban" />
              )}
              {isSent && !hasError && (
                <FaCheck className="status-icon sent" title="Elküldve" />
              )}
              {hasError && (
                <FaExclamationTriangle 
                  className="status-icon error" 
                  title={`Hiba: ${message.errorMessage || 'Ismeretlen hiba'}`}
                />
              )}
            </div>
          )}
        </div>

        {/* Hiba üzenet */}
        {hasError && (
          <div className="message-error">
            <FaExclamationTriangle />
            <span>{message.errorMessage || 'Üzenet küldése sikertelen'}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default MessageItem;
